export const settingsNavPathV3 = {
  admin_dashboard: {
    index: "/settings/dashboard",
  },
  content: {
    pages: "/settings/pages",
    posts: "/settings/posts",
    spaces: "/settings/spaces",
    topics: "/settings/topics",
    moderation: "/settings/moderation",
    edit_moderation: "/settings/moderation/edit",
    posts_bulk_actions: "/settings/posts/bulk_actions",
    live_streams: "/settings/live_streams",
    files: "/settings/files",
    theme: "/settings/theme",
  },
  plus: {
    index: "/settings/plus",
    billing: "/settings/plus/billing",
    push_notifications: "/settings/plus/push-notifications",
    landing_page: "/settings/branded_apps_builder_landing_page",
    lite: "/settings/plus/lite",
  },
  email: {
    overview: "/settings/emails",
    broadcast: "/settings/emails/broadcast",
    new_broadcast: "/settings/emails/broadcast/new",
    settings: "/settings/emails/settings",
    forms: "/settings/emails/forms",
  },
  connect: {
    overview: "/settings/connect",
  },
  members: {
    manage: "/audience/manage",
    invite: "/members/invite/details",
    invite_access: "/members/invite/access",
    invite_emails: "/members/invite/emails",
    invite_paywalls: "/members/invite/paywalls",
    bulk_import: "/members/bulk_import",
    bulk_logs: "/settings/members/bulk_import_tasks",
    onboarding: "/members/onboarding",
    onboarding_access: "/members/onboarding/access",
    import_contacts: "/contacts/import",
    onboarding_workflows: "/members/onboarding/workflows",
    gamification: "/settings/gamification",
    invitation_links: "/members/invitation_links",
    new_invitation_link: "/members/invitation_links/new",
    new_invitation_link_details: "/members/invitation_links/new/details",
    new_invitation_link_access: "/members/invitation_links/new/access",
    new_invitation_link_paywalls: "/members/invitation_links/new/paywalls",
    edit_invitation_link_details: "/members/invitation_links/:id/edit/details",
    edit_invitation_link_access: "/members/invitation_links/:id/edit/access",
    edit_invitation_link_paywalls:
      "/members/invitation_links/:id/edit/paywalls",
    edit_invitation_link: "/members/invitation_links/:id/edit",
    member_tags: "/settings/member_tags",
    new_member_tags: "/settings/member_tags/new",
    edit_member_tags: "/settings/member_tags/:id/edit",
    profile_fields: "/members/profile_fields",
    activity_logs: "/settings/members/activity_logs",
    access_groups: "/settings/access_groups",
    segments: "/settings/segments",
  },
  workflows: {
    all: "/settings/workflows",
    history: "/settings/workflows/history",
  },
  paywalls: {
    index: "/settings/paywalls",
    coupons: "/settings/coupons",
    subscription_groups: "/settings/paywall_groups",
    transactions: "/settings/paywall_charges",
    subscriptions: "/settings/paywall_subscriptions",
    taxes: "/settings/paywall_tax_settings",
    bulk_logs: "/settings/paywall_bulk_logs",
    payment_settings: "/settings/paywall_payment_settings",
  },
  affiliates: {
    directory: "/settings/affiliates_directory",
    commissions: "/settings/affiliates_commissions",
    settings: "/settings/affiliates_settings",
  },
  plans: {
    general: "/settings/plans",
    billing: "/settings/billing",
    brandedApps: "/settings/branded_apps",
  },
  developers: {
    overview: "/settings/developers",
    api: "/settings/api",
    new_api: "/settings/api/new",
  },
  live_streams: {
    live_streams: "/settings/live_streams",
  },
  settings: {
    general: "/settings",
    onboarding: "/settings/onboarding",
    community_ai: "/settings/community_ai",
    custom_domain: "/settings/custom_domain",
    weekly_digest: "/settings/weekly_digest",
    embed: "/settings/embed",
    single_sign_on: "/settings/sso",
    single_sign_on_verify_connection: "/custom_logins/debug_sessions",
    messaging: "/settings/messaging",
    legal: "/settings/legal",
    discover: "/settings/discover",
    mobile_app: "/settings/mobile_app",
  },
  // [AfterAnalyticsV4] TODO: rename this group to just analytics
  analytics_v2: {
    index: "/settings/analytics",
    members: "/settings/analytics/members",
    website: "/settings/analytics/website",
    videos: "/settings/analytics/videos",
    post_comments: "/settings/analytics/post_comments",
    messages: "/settings/analytics/messages",
    spaces: "/settings/analytics/spaces",
    events: "/settings/analytics/events",
    courses: "/settings/analytics/courses",
    devices: "/settings/analytics/devices",
    payments: "/settings/analytics/payments",
  },
  site: {
    index: "/settings/home",
    navigation: "/settings/navigation",
    code_snippets: "/settings/code_snippets",
    seo: "/settings/seo",
    redirects: "/settings/redirects",
  },
  community_inbox: {
    index: "/settings/ai-inbox",
  },
  community_bot: {
    knowledge: "/settings/ai-agents/knowledge",
    agents: "/settings/ai-agents/agents",
  },
  branded_apps_builder_ui: {
    index: "/settings/branded_apps_builder_ui",
  },
} as const;

export type SettingsNavPathV3 = keyof typeof settingsNavPathV3;

export const isSettingsNavPathV3 = (path: unknown): path is SettingsNavPathV3 =>
  typeof path === "string" && path in settingsNavPathV3;
